module.exports = __webpack_public_path__ + "static/media/operator.afd914c2.jpg";